class ProductCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.prevBtn = this.querySelector('[data-carousel-prev]');
    this.nextBtn = this.querySelector('[data-carousel-next]');
    if (this.track && this.prevBtn && this.nextBtn) {
      this.prevBtn.addEventListener('click', () => this.scrollByAmount(-1));
      this.nextBtn.addEventListener('click', () => this.scrollByAmount(1));
    }

    this.setupAddToCart();
  }

  scrollByAmount(direction) {
    const card = this.track.querySelector('.product-carousel-item');
    const gap = parseFloat(getComputedStyle(this.track).columnGap || '0');
    const amount = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
    this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  }

  setupAddToCart() {
    this.querySelectorAll('.product-carousel-add-to-cart').forEach((button) => {
      button.addEventListener('click', async (event) => {
        event.preventDefault();
        const variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;

        const label = button.querySelector('[data-default-label]');
        const originalText = label ? label.textContent : '';
        button.disabled = true;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });

          if (response.ok) {
            if (label) label.textContent = 'Ajouté !';
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          } else {
            if (label) label.textContent = 'Indisponible';
          }
        } catch (error) {
          if (label) label.textContent = 'Erreur';
        } finally {
          setTimeout(() => {
            if (label) label.textContent = originalText;
            button.disabled = false;
          }, 1500);
        }
      });
    });
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel);
}